import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './components/LanguageContext';
import { WaitlistProvider } from './components/WaitlistContext';
import { Marketing } from './pages/Marketing';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { FAQ } from './pages/FAQ';
import { DashboardLayout } from './components/dashboard/DashboardLayout';
import { Overview } from './pages/dashboard/Overview';
import { Accounts } from './pages/dashboard/Accounts';
import { Transactions } from './pages/dashboard/Transactions';
import { Reports } from './pages/dashboard/Reports';
import { Settlement } from './pages/dashboard/Settlement';
import { Settings } from './pages/dashboard/Settings';
export function App() {
  return <LanguageProvider data-id="element-0">
      <WaitlistProvider data-id="element-1">
        <BrowserRouter data-id="element-2">
          <Routes data-id="element-3">
            {/* Marketing Landing Page */}
            <Route path="/" element={<Marketing data-id="element-5" />} data-id="element-4" />

            {/* Legal & help */}
            <Route path="/privacy" element={<Privacy data-id="element-7" />} data-id="element-6" />
            <Route path="/terms" element={<Terms data-id="element-9" />} data-id="element-8" />
            <Route path="/faq" element={<FAQ data-id="element-11" />} data-id="element-10" />

            {/* Retailer Dashboard */}
            <Route path="/dashboard" element={<DashboardLayout data-id="element-13" />} data-id="element-12">
              <Route index element={<Overview data-id="element-15" />} data-id="element-14" />
              <Route path="accounts" element={<Accounts data-id="element-17" />} data-id="element-16" />
              <Route path="transactions" element={<Transactions data-id="element-19" />} data-id="element-18" />
              <Route path="reports" element={<Reports data-id="element-21" />} data-id="element-20" />
              <Route path="settlement" element={<Settlement data-id="element-23" />} data-id="element-22" />
              <Route path="settings" element={<Settings data-id="element-25" />} data-id="element-24" />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace data-id="element-27" />} data-id="element-26" />
          </Routes>
        </BrowserRouter>
      </WaitlistProvider>
    </LanguageProvider>;
}